<template>
  <destroy
    :question="sub18n.question"
    :submit="sub18n.submit"
    icon="trash-alt"
    method="delete"
    :url="url"
    @destroyed="destroyed"
  />
</template>

<script>
import _Destroy from "./_Destroy.vue";
export default {
  components: { destroy: _Destroy },
  props: ["project", "i18n"],
  computed: {
    sub18n() {
      return this.i18n.tab.remove;
    },
    url() {
      return this.$store.state.dashboard.projects.routes.remove.replace(
        ":id",
        this.project.id
      );
    },
  },
  methods: {
    destroyed() {
      this.$store.dispatch("dashboard/getPaginator");
      this.$emit("reload");

      if (this.$route.name === "project.remove") {
        this.$router.push({
          name: "project.index",
          params: {
            id: this.project.id,
            type: this.$route.params.type,
            locale: this.$route.params.locale,
          },
        });
      }
    },
  },
};
</script>
